import React from "react";
import videoOne from '../assets/video/BWEAI_LES_AI.mp4'
import videoTwo from '../assets/video/BWEAI_SALES_AIQUERY.mp4'
import aiBgImage from '../assets/image/ai-bg-image.png'
import aiBrainImage from '../assets/image/ai-brain.png'
import aiReportImage from '../assets/image/ai-report.png'
import aiYourselfImage from '../assets/image/ai-yourself.png'
import { FiShield } from "react-icons/fi";
import { FaRegStar } from "react-icons/fa";
import { MdOutlineDone } from "react-icons/md";
import { FaRegHeart } from "react-icons/fa6";

const AIArtificialIntelligence = ({ MarginTop }) => {

    return (
        <section id="ai" style={{ scrollMarginTop: MarginTop }}>
            <div className='home-section our_services_sec'>
                <div className="title-background-image">
                    <img src={aiBgImage} alt="Ai_background_image" />
                    <div className="section-badge">
                        <span className="title-side-line"></span>
                        <h5 className="badge-text">Artificial Intelligence</h5>
                        <span className="title-side-line"></span>
                    </div>
                    <div className="title-section">
                        <h1 className="head-title">Another Buzzword Gone <span>Wild</span></h1>
                        <span className="title-under-line"></span>
                        <p className="title-disc"> <span className="uniq-cont-text-colr">Show, Don't Tell!</span> Just like "low code," AI has become a term that every software company slaps on
                            their marketing materials. We could fill this page with vague promises about "AI-powered" this and "machine learning-driven" that. But we won't.</p>
                    </div>
                </div>
                <div className="service-content">
                    <h4 className="extra-size"> What We've Actually Built</h4>
                    <div className="service-line"></div>
                </div>
                <p className="mb-0">We have real, working AI capabilities that solve concrete problems in lending:</p>
                <div className="ai-card">
                    <div className="ai-icon-box">
                        <img src={aiBrainImage} alt="brain_icon_image" />
                    </div>
                    <div className="ai-content">
                        <div className="ai-title-row">
                            <div className="number"><span>01</span></div>
                            <h2>Local LLM Integration for Borrower Assessment</h2>
                        </div>
                        <p className="ai-discription">
                            Our system uses a locally deployed large language model to pre-judge
                            borrower viability based on specific parameters you define. We
                            deliberately chose local deployment because your borrowers' sensitive
                            financial data should never leave your infrastructure or cross
                            national borders.
                        </p>
                        <div className="info-box">
                            <div className="shield"><FiShield /></div>
                            <p>
                                It's not magic, it's intelligent analysis that helps your
                                underwriting team make faster, more informed decisions while
                                keeping complete control over your data.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="ai-card">
                    <div className="ai-icon-box green-image">
                        <img src={aiReportImage} alt="brain_icon_image" />
                    </div>
                    <div className="ai-content">
                        <div className="ai-title-row">
                            <div className="number green-one"><span>02</span></div>
                            <h2>Automated Report Generation</h2>
                        </div>
                        <p className="ai-discription">
                            Need detailed reports and summaries? Our LLM integration generates comprehensive, accurate reports so your
                            team can focus on decision-making instead of document formatting.
                        </p>
                        <div className="info-box">
                            <div className="shield green-shield"><FaRegStar /></div>
                            <p>
                                These aren't just features on a slide deck. They're <span style={{ color: "#00F48B" }}>live, working capabilities.</span>
                            </p>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 col-sm-6 col-md-6 col-lg-6">
                        <div className="video-box">
                            <video src={videoOne}
                                width="100%"
                                height="100%"
                                autoPlay
                                loop
                                muted
                                playsInline />
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 col-md-6 col-lg-6">
                        <div className="video-box">
                            <video src={videoTwo}
                                width="100%"
                                height="100%"
                                autoPlay
                                loop
                                muted
                                playsInline />
                        </div>
                    </div>
                </div>
                <div className="ai-card">
                    <div className="ai-icon-box perpule-image">
                        <img src={aiYourselfImage} alt="brain_icon_image" />
                    </div>
                    <div className="ai-content">
                        <div className="yourself-content">
                            <div className="yourself-discrip">
                                <h2>See It for <span>Yourself</span></h2>
                                <p>
                                    We don't expect you to take our word for it. Would you like to see these AI features in action? <a className="cont-link-btn" href="#contact">Contact us </a>
                                    for a live demonstration. We'll show you exactly how our AI capabilities work in real lending scenarios.
                                </p>
                            </div>
                            <div className="vertical-line"></div>
                            <div className="yourself-list-ui">
                                <ul>
                                    <li><span><MdOutlineDone /></span> Live demonstration</li>
                                    <li><span><MdOutlineDone /></span> Real lending scenarios</li>
                                    <li><span><MdOutlineDone /></span> No smoke and mirrors</li>
                                    <li><span><MdOutlineDone /></span> Practical technology that delivers results</li>
                                </ul>
                            </div>
                        </div>
                        <p className="yourself-bottom-cont"><FaRegHeart /> Because in our view, <span>working software</span> beats marketing promises every single time.</p>
                    </div>
                </div>
            </div>
        </section>
    )

}

export default AIArtificialIntelligence;